export default {
  item: state => id => state.items.find(item => item.id === id),
  items: state => state.items,
  loading: state => state.loading,
  sort: state => state.sort,
  total: state => state.total,
};
